import { useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";

import YesSelection from "./YesAction";
import NoSelection from "./NoAction";
import { useAxios } from "../../../../hooks";
import "../../details components/nodes.css";

export default function ActionSelection({ formikProps }) {
  const axios = useAxios();
  const [actions, setActions] = useState([]);
  const [newAction, setNewAction] = useState("");

  const { activeBot } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    axios({
      url: `/workflow/action/${activeBot.ID}`,
    }).then((response) => {
      if (response.status) {
        setActions(response.data);
      }
    });
  }, [axios, activeBot.ID, newAction]);

  return (
    <Fragment>
      <div style={{ display: "flex", gap: "10px" }}>
        {formikProps.values.stage >= 3 && (
          <div className="diamond-downward-icon">
            <div className="diamond-downward-arrow"></div>
          </div>
        )}

        {formikProps.values.stage >= 3 && (
          <div>
            <div className="add-actions-div">
              <div style={{ width: "100%", marginBottom: "10px" }}>
                <YesSelection
                  actions={actions}
                  setNewAction={setNewAction}
                  formikProps={formikProps}
                />
              </div>
            </div>
          </div>
        )}

        {formikProps.values.stage >= 3 && (
          <div className="diamond-downward-icon">
            <div className="diamond-downward-arrow"></div>
          </div>
        )}

        {formikProps.values.stage >= 3 && (
          <div>
            <div className="add-actions-div">
              <div style={{ width: "100%", marginBottom: "10px" }}>
                <NoSelection
                  actions={actions}
                  setNewAction={setNewAction}
                  formikProps={formikProps}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
}
